/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Dictate_OptionsInputs */



/**
* | output |
* | --- |
* | "Recording settings" |
*
* @param {Chat_Dictate_OptionsInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_dictate_options = /** @type {((inputs?: Chat_Dictate_OptionsInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Dictate_OptionsInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Opname-instellingen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres d'enregistrement")
	return /** @type {LocalizedString} */ ("Recording settings")
});